export default {
  brand: {
    name: 'Global Data',
    description: 'Global Data 致力于通过创新科技，赋能企业数字化转型，共创智能未来。'
  },
  quickLinks: {
    title: '快速链接',
    home: '首页',
    about: '关于我们',
    coreService: '核心服务',
    industrySolutions: '行业解决方案',
    caseStudies: '案例展示',
    resourceCenter: '资源中心',
    customerSupport: '客户支持',
    contact: '联系我们'
  },
  solutions: {
    title: '行业解决方案',
    finance: '金融行业',
    ticketAI: '工单AI助手',
    manufacturing: '制造业',
    healthcare: '医疗健康',
    government: '政府与公共服务'
  },
  contactInfo: {
    title: '联系方式',
    address: '上海市静安区西藏北路199号光明地产大厦1003-1室'
  },
  copyright: '© 2023 Global Data. All rights reserved.'
}
